import { render } from "./opportunities-list-modal.vue?vue&type=template&id=998c162c"
import script from "./opportunities-list-modal.vue?vue&type=script&lang=js"
export * from "./opportunities-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__